export const updateOtherValue = action => state => ({
  ...state,
  otherValue: action.value,
});

export const updateisOtherTouched = state => ({
  ...state,
  isOtherTouched: true,
});
